import {createAction, props} from '@ngrx/store';
import {EDeviceOrientationEnum} from '../models/device-orientation.enum';
import {IDeviceOrientationAngle, IDevicePermissions, IDeviceUserAgent} from '../models';
import {EDevicePermissions, EDevicePermissionState} from '../models/device-permissions.enum';
import {IGlobalError} from '../../../shared/shared-components/components/global-error-display/models/global-error';

//#region GLOBAL USER PREFERENCES
export const clearUserPreferencesState = createAction(
  '[USER DEVICE][GLOBAL] Clear User Preferences State',
);

//#endregion

//#region USER DEVICE - USER AGENT
export const getUserDeviceUserAgent = createAction(
  '[USER DEVICE][DEVICE] Get User Device User Agent',
);

export const getUserDeviceUserAgentSuccess = createAction(
  '[USER DEVICE][DEVICE] Get User Device User Agent Success',
  props<{ userAgent: IDeviceUserAgent }>(),
);

export const getUserDeviceUserAgentFailure = createAction(
  '[USER DEVICE][DEVICE] Get User Device User Agent Failure',
  props<{ error: IGlobalError }>(),
);

//#endregion

//#region USER DEVICE - ORIENTATION
export const getUserDeviceOrientation = createAction(
  '[USER DEVICE][DEVICE] Get User Device Orientation',
  props<{ orientation: EDeviceOrientationEnum }>(),
);
export const getUserDeviceOrientationAngles = createAction(
  '[USER DEVICE][DEVICE] Get User Device Orientation Angles',
  props<{ angle: IDeviceOrientationAngle }>(),
);

export const getUserScreenOrientationAngles = createAction(
  '[USER DEVICE][DEVICE] Get User Screen Orientation Angles',
  props<{ angle: number }>(),
);
//#endregion

//#region USER PERMISSIONS - USER DEVICE PERMISSIONS
export const getUserDevicePermission = createAction(
  '[USER DEVICE][PERMISSIONS] Get User Device Permission',
  props<{ permission: EDevicePermissions }>(),
);

export const getUserDevicePermissionSuccess = createAction(
  '[USER DEVICE][PERMISSIONS] Get User Device Permission Success',
  props<{ access: EDevicePermissionState, permission: EDevicePermissions }>(),
);

export const getUserDevicePermissionFailure = createAction(
  '[USER DEVICE][PERMISSIONS] Get User Device Permission Failure',
  props<{
    access: EDevicePermissionState,
    error: IGlobalError,
    permission: EDevicePermissions,
  }>(),
);
//#endregion

//#region SPECIFIED USER PERMISSIONS - IS USER SCREEN ROTATION LOCKED
export const getUserDevicePermissions = createAction(
  '[USER DEVICE][PERMISSIONS] Get User Device Permissions',
);

export const getUserDevicePermissionsSuccess = createAction(
  '[USER DEVICE][PERMISSIONS] Get User Device Permissions Success',
  props<{
    permissions: IDevicePermissions,
  }>(),
);

export const getUserDevicePermissionsFailure = createAction(
  '[USER DEVICE][PERMISSIONS] Get User Device Permissions Failure',
  props<{
    error: IGlobalError,
  }>(),
);
//#endregion

